enum ProfileTabType {
  Campaigns = "Campaigns",
  CampaignsWhereUserIsActiveSupporter = "Communities",
  Collected = "Collected",
  Created = "Created",
  CreatorStory = "Creator Story",
  Series = "Series",
}

export default ProfileTabType;
